"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEventSeasonProperty = exports.eventSeasonPropertyDefinition = void 0;
exports.eventSeasonPropertyDefinition = {
    name: 'event-season',
    type: 'asset',
    constraints: [
        {
            name: 'stencils',
            argument: ['event-season'],
        },
    ],
    multiple: false,
    view: { label: 'Season' },
};
const isEventSeasonProperty = (prop) => {
    return prop.name === exports.eventSeasonPropertyDefinition.name;
};
exports.isEventSeasonProperty = isEventSeasonProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQtc2Vhc29uLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvZXZlbnQtc2Vhc29uLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFLGNBQWM7SUFDcEIsSUFBSSxFQUFFLE9BQU87SUFDYixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLGNBQWMsQ0FBQztTQUMzQjtLQUNGO0lBQ0QsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFO0NBQ00sQ0FBQTtBQUkxQixNQUFNLHFCQUFxQixHQUFHLENBQUMsSUFBa0IsRUFBK0IsRUFBRTtJQUN2RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsscUNBQTZCLENBQUMsSUFBSSxDQUFBO0FBQ3pELENBQUMsQ0FBQTtBQUZZLFFBQUEscUJBQXFCLHlCQUVqQyJ9